module.exports = __webpack_public_path__ + "img/th.66b0b0c0.png";